import { Navigate, Outlet } from "react-router-dom";
export const ProtectedRoute = () => {
  let auth = { token: sessionStorage.getItem("token") };
  return auth.token ? <Outlet /> : <Navigate to="/login" />;
};
